import { Injectable, OnDestroy } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SplashScreenService implements OnDestroy {
  public showSplash$: Observable<'hidden' | 'visible' | 'destroyed'>;
  private showSplashSubject: BehaviorSubject<'hidden' | 'visible' | 'destroyed'>;

  constructor() {
    this.showSplashSubject = new BehaviorSubject<'hidden' | 'visible' | 'destroyed'>('destroyed');
    this.showSplash$ = this.showSplashSubject.asObservable();
  }

  showSplash(show: 'hidden' | 'visible' | 'destroyed') {
    if (Capacitor.isNativePlatform()) {
      if (show === 'visible') {
        SplashScreen.show();
      } else {
        SplashScreen.hide();
      }
    } else {
      this.showSplashSubject.next(show);
    }
  }

  ngOnDestroy(): void {
    this.showSplashSubject.complete();
    this.showSplashSubject.unsubscribe();
  }
}
